<template>
  <div style="height: 85%">
    <ExportTableData
      ref="pobierz"
      :column-defs="columnDefs"
      :grid-options="gridOptions"
    ></ExportTableData>
    <v-layout>
      <v-flex xs7>
        <v-layout
          class="table--first-row"
          row
          wrap
        >
          <v-flex class="table__wrapper--center">
            <v-icon
              class="table__btn--blue"
              v-show="selectedRow"
              @click="openPwrCard"
            >note</v-icon>
            <p
              class="caption"
              v-show="selectedRow"
              @click="openPwrCard"
            >OTWÓRZ KARTĘ</p>
          </v-flex>
          <v-spacer />
        </v-layout>
        <v-layout
          row
          wrap
        >
          <v-flex class="table__wrapper--center">
            <v-icon
              @click="'pobierz' in $refs && $refs.pobierz.showExportMenu($event)"
              class="table__btn--blue"
            >cloud_download</v-icon>
            <p
              class="caption"
              @click="'pobierz' in $refs && $refs.pobierz.showExportMenu($event)"
            >POBIERZ REJESTR</p>
            <v-icon
              class="table__btn--padding"
              v-show="selectedRow"
              @click="zoomToGeometry"
            >zoom_in</v-icon>
            <p
              class="caption"
              v-show="selectedRow"
              @click="zoomToGeometry"
            >PRZYBLIŻ</p>
          </v-flex>
          <v-spacer />
        </v-layout>
      </v-flex>
      <v-flex
        xs5
        class="table__wrapper--center table__wrapper--filter"
      >
        <v-layout
          align-right
          justify-end
        >
          <v-text-field
            type="text"
            v-model="filter"
            placeholder="Treść filtra"
            clearable
            :hint="numberFiltered + '/' + numberAll"
            persistent-hint
            filled
          >
          </v-text-field>
        </v-layout>
      </v-flex>
    </v-layout>
    <ag-grid-vue
      class="ag-theme-balham"
      :gridOptions="gridOptions"
      style="height: 90%"
    ></ag-grid-vue>
  </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import ExportTableData from "../../shared/ExportTableData";

export default {
  name: "App",
  data: () => ({
    filter: "",
    numberAll: '0', //hint z textfielda wymaga, by wartość była typu string
    numberFiltered: '0', //hint z textfielda wymaga, by wartość była typu string
    selectedRow: undefined,
    statusFilter: '',
    tableTitle: "prwTable",
    partitions: [],
    features: []
  }),
  components: {
    AgGridVue,
    ExportTableData,
  },
  watch: {
    filter(nV) {
      this.gridOptions.api.setQuickFilter(nV);
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length.toString();
    }
  },
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    gridOptions() {
      let gridOptions = {
        rowData: this.loadData(),
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Trwa ładowanie danych</span>',
        columnDefs: this.columnDefs,
        enableSorting: "true",
        enableFilter: "true",
        enableColResize: "true",
        onGridReady: this.onGridReady,
        onColumnMoved: this.onColumnMoved,
        onColumnResized: this.onColumnMoved,
        onFilterChanged: this.filterColumn,
        onSelectionChanged: this.onSelectionChanged,
        rowSelection: "single",
        localeText: {
          contains: "Zawiera",
          notContains: "Nie zawiera",
          lessThan: "Mniejsza niż",
          greaterThan: "Większa niż",
          equals: "Równa się",
          notEqual: "Nie równa się",
          startsWith: "Zaczyna się",
          endsWith: "Kończy się",
          noRowsToShow: "Brak danych"
        }
      };
      return gridOptions;
    }
  },
  beforeMount() {
    this.columnDefs = [
      {headerName: "ID", field: "id", sort: "asc", width: 100},
      {headerName: "Rodzaj sieci", field: "properties.net_kind"},
      {headerName: "Typ lokalizacji", field: "properties.location_type"},
      {headerName: "Opis dodatkowy", field: "properties.description"},
      {headerName: "Wzorzec rozbioru", field: "properties.pattern"},
      {headerName: "Miejscowość", field: "properties.address_place"},
      {headerName: "Ulica", field: "properties.address_street"},
      {
        headerName: "Numer porządkowy", 
        field: "properties.address_order",
        comparator: (_as, bs) => {
          if (_as && bs) {
            var a, b, a1, b1, i= 0, n, L,
            rx=/(\.\d+)|(\d+(\.\d+)?)|([^\d.]+)|(\.\D+)|(\.$)/g;
            if(_as=== bs) return 0;
            a= _as.toLowerCase().match(rx);
            b= bs.toLowerCase().match(rx);
            L= a.length;
            while(i<L){
                if(!b[i]) return 1;
                a1= a[i],
                b1= b[i++];
                if(a1!== b1){
                    n= a1-b1;
                    if(!isNaN(n)) return n;
                    return a1>b1? 1:-1;
                }
            }
            return b[i]? -1:0;
          }
          return -1;
        } 
      },
      {headerName: "Powiat", field: "properties.address_county"},
      {headerName: "Województwo", field: "properties.address_voivodeship"},
      {
        headerName: "Numer działki", 
        field: "properties.address_plot",
        comparator: (_as, bs) => {
          if (_as && bs) {
            var a, b, a1, b1, i= 0, n, L,
            rx=/(\.\d+)|(\d+(\.\d+)?)|([^\d.]+)|(\.\D+)|(\.$)/g;
            if(_as=== bs) return 0;
            a= _as.toLowerCase().match(rx);
            b= bs.toLowerCase().match(rx);
            L= a.length;
            while(i<L){
                if(!b[i]) return 1;
                a1= a[i],
                b1= b[i++];
                if(a1!== b1){
                    n= a1-b1;
                    if(!isNaN(n)) return n;
                    return a1>b1? 1:-1;
                }
            }
            return b[i]? -1:0;
          }
          return -1;
        } 
      },
      {headerName: "Powiązane przyłącze", field: "properties.parent_pipe"},
      {headerName: "Numer eksploatacyjny", field: "properties.registry_exploitation"},
      {headerName: "Sposób pozyskania danych", field: "properties.acquisition"},
      {headerName: "Status", field: "properties.status"},
      {headerName: "Geometria", field: "geometry", hide: true}
    ];
  },
  methods: {
    filterColumn() {
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length.toString();
    },
    loadData() {
      const self = this;
      let payload = {
        layername: 'partitions',
        srid: 2180,
        with_geometry: true
      }
      this.$store.dispatch('getFeatures', payload).then(r => {
        this.partitions = r.features;
        this.numberAll = r.features.length;
        this.numberFiltered = this.numberAll;
        this.gridOptions.api.setRowData(r.features);
      })
    },
    onColumnMoved(params) {
      const columnState = JSON.stringify(
        this.gridOptions.columnApi.getColumnState()
      );
      localStorage[this.tableTitle] = columnState;
    },
    onGridReady(params) {
      if(localStorage[this.tableTitle]) {
        const columnState = JSON.parse(localStorage[this.tableTitle]);
        if(columnState) {
          this.gridOptions.columnApi.setColumnState(columnState);
        }
      }
    },
    onSelectionChanged() {
      this.selectedRow = this.gridOptions.api.getSelectedRows()[0];
      // this.$root.$emit('removeMapLayer');
    },
    openPwrCard() {
      this.loadData();
      let payload = {
        object_id: this.selectedRow.id,
        object_type: 'partitions',
        limit: 5,
        events_count: true
      };
      this.partitions = this.partitions.filter(el => el.id == this.selectedRow.id);
      this.$root.$emit('loadPrwCard', this.partitions);
      this.$store.dispatch("getFeatureEvents", payload).then(() => {
        this.show("prwCard");
      })

    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    zoomToGeometry() {
      this.$root.$emit("zoomToFeature", this.selectedRow, {
        srid: this.srid
      });
    }

  },
  mounted() {
    this.$root.$on("edited_prw", this.loadData);
    this.$root.$on("loadWatermeters", this.loadData);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/table/PrwTable.vue